import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { usePrefs } from 'wsm-common-data';
import { g } from '../../global-constants';

const ResultsHeading = ({ label, ariaLabelledById }) => {
	const { display } = usePrefs();
	const isPanelMode = display === g.NAVIGATION_DRAWER;
	// Panel mode's content wrapper already supplies the horizontal inset
	// (--sts-panel-content-padding-x), so px-4 here would double it.
	// h4 matches the drawer's own section-heading scale, the same size
	// FlyOutContent's "Search" heading uses in panel mode.
	const panelClasses = ['h4', 'sts-panel-heading'];
	const defaultClasses = ['ddc-font-size-xlarge', 'px-4'];
	const headingClassName = setClassNames([
		...(isPanelMode ? panelClasses : defaultClasses),
		display === g.EMBEDDED && 'widget-heading'
	]);
	const labelAttributes = {
		id: ariaLabelledById,
		className: headingClassName
	};
	return <h3 {...labelAttributes}>{label}</h3>;
};

ResultsHeading.propTypes = {
	label: PropTypes.string.isRequired,
	ariaLabelledById: PropTypes.string.isRequired
};

export default ResultsHeading;
